import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosApiInstance } from "../../../app/axios";
import { API_URL } from "../../../app/config";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IAdminSettingDetails } from "../adminsettingModel";

export const updateHandlingFees = createAsyncThunk(
  "AdminSettings/UpdateHandlingFees",
  async (UserData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/AdminSettings/UpdateHandlingFees`,
        UserData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating user:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getHandlingFeesByID = createAsyncThunk(
  "AdminSettings/FindByIDHandlingFees",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/AdminSettings/FindByIDHandlingFees`,
        {
          ID: 1,
        }
      );
      const result = response.data?.Data as any;
      return {
        International_Cancellation_Fee: result?.International_Cancellation_Fee,
        International_Conv_Fee: result?.International_Conv_Fee,
        Domestic_Cancellation_Fee: result?.Domestic_Cancellation_Fee,
        Domestic_Conv_Fee: result?.Domestic_Conv_Fee,
        Domestic_Remarks: result?.Domestic_Remarks,
        International_Remarks: result?.International_Remarks,
        // IsActive: result.IsActive === true ? 1 : 2,
        GSTPer: result?.GSTPer,
      } as IAdminSettingDetails;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching handling fee details:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
